import React from "react";
import { UserPlus, X } from "lucide-react";

export function CoCoachPicker({ staff, mainCoachId, value, onChange }) {
  const options = staff.filter((s) => s.user_id !== mainCoachId && !value.includes(s.user_id));
  const byId = Object.fromEntries(staff.map((s) => [s.user_id, s]));
  return (
    <div data-testid="appt-co-coaches">
      <label className="text-xs font-bold uppercase tracking-overline text-slate-500 mb-2 block">Weitere Coaches einladen</label>
      <div className="flex flex-wrap gap-2 mb-2">
        {value.map((id) => (
          <span key={id} className="inline-flex items-center gap-1 text-xs bg-slate-900 text-white px-2.5 py-1" data-testid={`appt-co-coach-${id}`}>
            {byId[id]?.name || id}
            <button type="button" onClick={() => onChange(value.filter((x) => x !== id))} className="opacity-70 hover:opacity-100" data-testid={`appt-co-coach-remove-${id}`}><X size={12} /></button>
          </span>
        ))}
      </div>
      {options.length > 0 && (
        <div className="flex items-center gap-2 border-b border-slate-300">
          <UserPlus size={14} className="text-slate-400" />
          <select value="" onChange={(e) => e.target.value && onChange([...value, e.target.value])} className="flex-1 bg-transparent py-2 text-sm outline-none" data-testid="appt-co-coach-select">
            <option value="">Coach hinzufügen …</option>
            {options.map((s) => <option key={s.user_id} value={s.user_id}>{s.name}</option>)}
          </select>
        </div>
      )}
      <p className="text-[11px] text-slate-500 mt-1">Eingeladene Coaches bekommen eine E-Mail und die Google-Einladung mit Meet-Link und können den Termin bearbeiten und dokumentieren.</p>
    </div>
  );
}
